export default __webpack_public_path__ + "static/ryo_kato-0dbed703ec2b2c8ff52cbeeabd13a3a4.jpeg";